/* eslint-disable no-console */
import {ISlidePreview} from '../incase-domain/proptypes/slidePreview';
import {httpPost} from './http.service';

export const getSlidePreviews = (slideIds: string[]): Promise<ISlidePreview[]> => {
    return httpPost(`editor/slides/getPreview`, slideIds).catch((error) => {
        console.log(error);
    });
};

export const generatePresentationSlidePreviews = async (presentationId: string): Promise<{queued: number}> => {
    const result = await httpPost<{queued: number}>(`editor/slides/generatePreviews/${presentationId}`, {});
    if (!result || typeof result.queued !== 'number') {
        throw new Error('Failed to queue slide previews');
    }
    return result;
};
